/**
 * C7-3: dataUsage-primary preselection (SI-3 user pin).
 *
 * `dataUsage` is what the AI ACTUALLY cited on the last generation. HB-5 reads
 * it for the provenance chip and the cited-first sort of the override tables
 * (`blockOverrideSelection`), with exact DataMappingViewerV2 parity,
 * item-for-item. `sourceDataMapping` (authoring-time intent) is ONLY the
 * fallback when dataUsage is empty. This inverts the pre-C3 helper's order —
 * do not "restore" the old mapping-first behavior.
 */
import type { StrategyBlock } from '@segmently/schema-models/strategy';

function readPathList(items: unknown): string[] {
  if (!Array.isArray(items)) return [];
  return items
    .map((item) => (item as { sourcePath?: unknown } | null | undefined)?.sourcePath)
    .filter((path): path is string => typeof path === 'string' && path.length > 0);
}

/** Ordered, deduplicated citation paths of one block. */
export function extractSourceDataPaths(block: StrategyBlock | null): string[] {
  const dataUsage = (block as { dataUsage?: { items?: unknown; dataMappingItems?: unknown } } | null)?.dataUsage;
  const dataUsagePaths = readPathList(dataUsage?.items ?? dataUsage?.dataMappingItems);
  const paths = dataUsagePaths.length > 0
    ? dataUsagePaths
    : readPathList((block as { sourceDataMapping?: unknown } | null)?.sourceDataMapping);
  return [...new Set(paths)];
}
